import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import type { CreateProductRequest, UpdateProductRequest } from "@opus-dt/shared-types";
import type { Product } from "../../types/products.types.js";

export type { Product } from "../../types/products.types.js";

const QK = ["products"] as const;

export function useProducts() {
  return useQuery<Product[]>({
    queryKey: QK,
    queryFn: () => api.get<Product[]>("/api/v1/products"),
  });
}

export function useCreateProduct() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateProductRequest) => api.post<Product>("/api/v1/products", data),
    meta: { skipErrorToast: true },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useUpdateProduct() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateProductRequest }) =>
      api.patch<Product>(`/api/v1/products/${id}`, data),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: QK });
      // Spec 081 — a equivalência do produto é HERDADA por todo contador que o cita, e é ela que a
      // lista de contadores exibe. Alterá-la sem invalidar deixaria a tela mostrando o fator
      // antigo num contador que já converte pelo novo. Prefixo largo: as máquinas que citam o
      // produto não são conhecidas aqui, e errar para menos deixaria número velho em tela.
      void qc.invalidateQueries({ queryKey: ["parameters"] });
    },
  });
}

export function useDeleteProduct() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/api/v1/products/${id}`),
    meta: { skipErrorToast: true },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
